"use strict";

exports.unit = {};



//////////////////
// WEBPACK FOOTER
// ./output/Data.Unit/foreign.js
// module id = 283
// module chunks = 0